import React from "react";
import Results from "./pages/results";
import HeaderPage from "./pages/header-page";

function AppResults() {
    return (
        <>
            <HeaderPage />
            <Results />
        </>
    );
}

export default AppResults;